export const SearchItem = {
  Telephone: 'telephone',
  ReservationId: 'reservationId',
  GuestName: 'guestName',
  GuestNameKana: 'guestNameKana',
  QR: 'qr',
  RoomKey: 'roomKey',
} as const

export type SearchItemType = (typeof SearchItem)[keyof typeof SearchItem]

export type SearchSetting = {
  inputType: SearchItemType
  isEnabled: boolean
}
